import { Routes } from '@angular/router';
import { routes as schemaRoutes } from './api-schemas.routes';
import { apiOperationResolver } from './resolvers/api-operation.resolver';
import { apiPathResolver } from './resolvers/api-path.resolver';
import { apiResponseResolver } from './resolvers/api-response.resolver';
import { apiResolverFn } from './resolvers/api.resolver';

export const routes: Routes = [
	{
		path: '',
		data: { breadcrumb: 'API_LIST.BREADCRUMBS.MAIN' },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./components/api-list/api-list.component').then(
						(component) => component.ApiListComponent
					)
			},
			{
				path: 'add',
				data: { breadcrumb: 'API_EDITION.BREADCRUMBS.ADD' },
				loadComponent: () =>
					import('./components/api-edition/api-edition.component').then(
						(component) => component.ApiEditionComponent
					)
			},
			{
				path: ':apiId',
				resolve: { value: apiResolverFn },
				data: {
					breadcrumb: (data: any) =>
						data.value.name || 'API_EDITION.BREADCRUMBS.EDIT'
				},
				children: [
					{
						path: '',
						loadComponent: () =>
							import('./components/api-edition/api-edition.component').then(
								(component) => component.ApiEditionComponent
							)
					},
					{
						path: ':infoId',
						children: [
							...schemaRoutes,
							{
								path: 'paths',
								data: { breadcrumb: 'API_PATHS.TITLES.BREADCRUMB' },
								children: [
									{
										path: '',
										loadComponent: () =>
											import(
												'./components/api-path-list/api-path-list.component'
											).then((component) => component.ApiPathListComponent)
									},
									{
										path: ':pathId',
										resolve: { path: apiPathResolver },
										data: {
											breadcrumb: (data: any) =>
												`${data.path?.description ?? data.path.pathValue}`
										},
										children: [
											{
												path: '',
												loadComponent: () =>
													import(
														'./components/api-path/api-path.component'
													).then((component) => component.ApiPathComponent)
											},
											{
												path: 'operations',
												data: {
													breadcrumb: 'API_OPERATION.TITLES.BREADCRUMB',
													nonNavigable: true
												},
												children: [
													{
														path: '',
														loadComponent: () =>
															import(
																'./components/api-operation-list/api-operation-list.component'
															).then(
																(component) =>
																	component.ApiOperationListComponent
															)
													},
													{
														path: ':operationId',
														resolve: { operation: apiOperationResolver },
														data: {
															breadcrumb: (data: any) =>
																`${data.operation.summary}`,
															nonNavigable: false
														},
														children: [
															{
																path: '',
																loadComponent: () =>
																	import(
																		'./components/api-operation/api-operation.component'
																	).then(
																		(component) =>
																			component.ApiOperationComponent
																	)
															},
															...schemaRoutes,
															{
																path: 'responses',
																data: {
																	breadcrumb: 'API_RESPONSE.BREADCRUMBS.MAIN',
																	nonNavigable: true
																},
																children: [
																	{
																		path: ':responseId',
																		resolve: { response: apiResponseResolver },
																		data: {
																			breadcrumb: (data: any) =>
																				`${data.response.description}`,
																			nonNavigable: false
																		},
																		loadComponent: () =>
																			import(
																				'./components/api-response/api-response.component'
																			).then(
																				(component) =>
																					component.ApiResponseComponent
																			)
																	}
																]
															}
														]
													}
												]
											}
										]
									}
								]
							}
						]
					}
				]
			}
		]
	}
];
